<template>
  <div class="team">
    <v-dialog
      content-class="white"
      persistent
      v-model="progressLoad"
      max-width="80px"
    >
      <v-progress-circular
        :size="50"
        indeterminate
        color="blue"
      ></v-progress-circular>
    </v-dialog>
    <Header active="Users" />
    <TopSection heading="Users" user="J K" :hideSearch="true" />
    <v-dialog v-model="errorDialog" persistent max-width="522px">
      <div class="notification-heading standard-height blue pr-4">
        <v-icon
          @click="usersError || responseWarnings.length ? closeModal() : $router.push('/users')"
          class="white body-2 blue--text notification-close mr-1"
          >close</v-icon
        >
      </div>
      <div :class="`notification-content white${responseWarnings.length ? ' warnings' : ''}`">
        <span class="primary--text font-weight-bold">
          <div>
            <p>{{ usersError ? usersError: 'An error has occurred.' }}<p>
            <div v-if="responseWarnings.length">
              <p class="warning-list-item error--text" v-for="warning in responseWarnings" :key="warning">{{ warning.message }}</p>
            </div>
            <p v-if="showWarrningAdditionalInfo" class="green--text">All other users have been successfully created</p>
          </div>
          </span
        >
      </div>
    </v-dialog>
    <v-dialog v-model="success" persistent max-width="522px">
      <div class="notification-heading standard-height blue pr-4">
        <v-icon
          @click="$router.push(`/users`)"
          class="white body-2 blue--text notification-close mr-1"
          >close</v-icon
        >
      </div>
      <div class="notification-content white">
        <span class="primary--text font-weight-bold"
          >User successfully
          {{ userId ? (deleted ? "deleted" : "edited") : "created" }}</span
        >
      </div>
    </v-dialog>

    <v-form autocomplete="off">
      <v-container class="pt-3" grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 md8 xl6>
            <v-layout row wrap class="form-section create-bulk-users">
              <v-flex xs12>
                <div
                  class="standard-height blue py-4 px-4 cc__box-shadow relative"
                >
                  <span class="pl-3 white--text subheading font-weight-bold"
                    >New Users</span
                  >
                </div>

                <div
                  v-for="email in usersEmailFieldCount"
                  :key="email"
                  class="relative"
                >
                  <div
                    v-if="check(bulkUsers.emails[email - 1])"
                    class="green valid-email-icon"
                  >
                    <v-icon class="white--text">check</v-icon>
                  </div>
                  <v-text-field
                    class="mb-1__custom"
                    maxlength="100"
                    v-model="bulkUsers.emails[email - 1]"
                    solo
                    flat
                    height="66"
                    placeholder="Email Address"
                    :onkeyup="check(bulkUsers.emails[email - 1])"
                  >
                  </v-text-field>
                </div>
                <p v-if="usersError" class="mt-3 v-messages error--text bulk-users-error">{{ usersError }}</p>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm5>
                <v-btn
                  @click="addMoreUsers"
                  block
                  large
                  color="blue"
                  :disabled="this.disableAddFieldsButton"
                  class="mt-3 pl-4 pr-3 text-icon-button ml-0"
                >
                  <span
                    class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3"
                    >More emails</span
                  >
                  <v-icon right class="white--text title">{{
                    userId ? "save" : "add"
                  }}</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm5>
                <v-btn
                  block
                  large
                  color="blue"
                  class="mt-3 pl-4 pr-3 text-icon-button ml-0 relative csv-uploader-button"
                >
                  <input
                    id="csv-uploader"
                    ref="csvFileRef"
                    model="csvFile"
                    type="file"
                    @change="importFromCSV()"
                  />
                  <span
                    v-if="!csvFileName"
                    class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3"
                    >Import from CSV</span
                  >
                  <span
                    v-if="csvFileName"
                    class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3 ellipsis--text"
                    >{{ csvFileName }}</span
                  >
                </v-btn>
                <p v-if="csvFileErrorType" class="red--text">
                  Please insert a csv file
                </p>
                <p v-if="csvFileErrorFormat" class="red--text">
                  Wrong formatted file
                </p>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="form-section">
              <v-flex xs12>
                <div
                  class="standard-height blue py-4 px-4 cc__box-shadow relative"
                >
                  <span class="pl-3 white--text subheading font-weight-bold"
                    >Authentication method</span
                  >
                </div>
                <v-radio-group
                  name="authMethod"
                  :error-messages="errors.collect('authMethod')"
                  v-model="authMethod"
                  column
                  v-validate="'required'">
                  <div
                    class="standard-height mb-1__custom white relative display-flex auth-method__checkbox"
                  >
                    <v-radio
                      label="Single Sign On (SSO)"
                      color="blue"
                      value="3"
                    ></v-radio>
                  </div>
                  <div
                    class="standard-height mb-1__custom white relative display-flex auth-method__checkbox"
                  >
                    <v-radio color="blue" value="1">
                      <template slot="label">
                        <div class="html-label">
                          <span>Local User (Username and Password)</span>
                          <span class="label__info">Email Verification</span>
                        </div>
                      </template>
                    </v-radio>
                  </div>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="form-section mb-4">
              <v-flex xs12 sm6>
                <div
                  class="standard-height blue py-4 px-4 cc__box-shadow relative"
                >
                  <span class="pl-3 white--text subheading font-weight-bold"
                    >Contract</span
                  >
                </div>
                <v-select
                  height="66"
                  background-color="white"
                  color="primary"
                  :items="contractItemsSelect"
                  item-text="description"
                  item-value="id"
                  label="Contract"
                  append-icon="keyboard_arrow_down"
                  v-model="selectedContract"
                  :hide-details="true"
                  solo
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <div
                  class="standard-height blue py-4 px-4 cc__box-shadow relative"
                >
                  <span class="pl-3 white--text subheading font-weight-bold"
                    >Branding Group</span
                  >
                </div>
                <v-select
                  height="66"
                  background-color="white"
                  color="primary"
                  :items="officeItems"
                  item-text="name"
                  item-value="officeId"
                  label="Office"
                  append-icon="keyboard_arrow_down"
                  v-model="selectedOffice"
                  :hide-details="true"
                  v-validate="userId ? '' : 'required'"
                  data-vv-name="selectedOffice"
                  :error-messages="errors.collect('selectedOffice')"
                  solo
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="form-section">
              <v-flex xs12>
                <div
                  class="standard-height blue py-4 px-4 cc__box-shadow relative"
                >
                  <span class="pl-3 white--text subheading font-weight-bold"
                    >Add to Teams</span
                  >
                </div>
                <simplebar
                  scrollbarMinSize="5"
                  data-simplebar-auto-hide="false"
                  class="team-selector-container"
                >
                  <div v-for="team in teams" :key="team.name">
                    <div class="standard-height white relative pl-3 pr-4">
                      <v-checkbox
                        :label="`${team.name}`"
                        :value="`${team.teamId}`"
                        required
                        dark--text
                        :id="`team-${team.teamId}`"
                        v-model="selectedTeam"
                        class="cc__checkbox label__left full-width pl-4 bold__icon"
                      >
                      </v-checkbox>
                    </div>
                    <v-divider></v-divider>
                  </div>
                </simplebar>
              </v-flex>
            </v-layout>

            <v-flex v-if="userId && userId != currentUserId" xs12>
              <v-checkbox
                label="Disable User"
                dark--text
                large
                class="large font-weight-bold cc__checkbox mr-3 mb-2 mt-2"
                v-model="user.isDisabled"
              >
              </v-checkbox>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm5>
                <v-btn
                  @click="submit"
                  block
                  large
                  color="grey lighten-1"
                  class="mt-3 pl-4 pr-3 text-icon-button ml-0"
                >
                  <span
                    class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3"
                    >Create Users</span
                  >
                  <v-icon right class="white--text title">{{
                    userId ? "save" : "add"
                  }}</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm5>
                <v-btn
                  @click="$router.push(`/users`)"
                  block
                  large
                  color="grey lighten-1"
                  class="mt-3 pl-4 pr-3 text-icon-button ml-0"
                >
                  <span
                    class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3"
                    >Cancel</span
                  >
                </v-btn>
              </v-flex>
              <v-flex v-if="userId && currentUserId != userId" xs12 sm5>
                <v-btn
                  @click="dialog = true"
                  block
                  large
                  color="grey lighten-1"
                  class="mt-3 pl-4 pr-3 text-icon-button ml-0"
                >
                  <span
                    class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3"
                    >Delete</span
                  >
                  <v-icon right class="white--text title">delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import TopSection from "../components/TopSection.vue";
import Header from "../components/Header.vue";
import router from "../router";
import Vue from "vue";
import VeeValidate from "vee-validate";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import userService from "../services/user";

const DEFAULT_USER_EMAIL_FIELDS_COUNT = 5;
const INCREMENT_USER_EMAIL_FIELDS_COUNT = 3;
const MAX_EMAIL_FIELDS = 50;
const EMAIL_REGEX = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/;

Vue.use(VeeValidate);
export default {
  name: "App",
  components: {
    Header,
    TopSection,
    simplebar,
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },
  data() {
    return {
      progressLoad: false,
      errorDialog: false,
      dialog: false,
      show: true,
      companyId: sessionStorage.companyId,
      currentUserId: sessionStorage.userId,
      success: false,
      deleted: false,
      userId: this.$route.params.id,
      contractItems: null,
      officeItems: null,
      teams: null,
      contractItemsSelect: [],
      authMethod: "",
      usersEmailFieldCount: DEFAULT_USER_EMAIL_FIELDS_COUNT,
      bulkUsers: {
        emails: [],
      },
      csvFile: "",
      csvFileName: null,
      csvFileErrorType: false,
      csvFileErrorFormat: false,
      disableAddFieldsButton: false,
      responseWarnings: [],
      user: {
        firstName: "",
        lastName: "",
        email: "",
        isDisabled: false,
      },
      selectedContract: "",
      selectedOffice: "",
      selectedTeam: [],
      usersError: null,
      showWarrningAdditionalInfo: false,
      dictionary: {
        custom: {
          csvFile: {
            image: () => "Accepted types: .csv",
          },
          authMethod: {
            required: () => 'Select an authentication method for new users'
          },
        },
      },
    };
  },
  methods: {
    contractDataToArray(contractData) {
      this.contractItems = this.contractItems.data;
      for (let j = 0; j < this.contractItems.length; j++) {
        let descriptionContract = this.contractItems[j].contractId;
        let description = this.contractItems[j].description;
        if (description && description.length > 25) {
          description = description.slice(0, 25) + "...";
        }
        if (description != "") {
          descriptionContract = descriptionContract + " - " + description;
        }
        this.contractItemsSelect.push({
          id: this.contractItems[j].contractId,
          description: descriptionContract,
        });
      }
    },
    closeModal() {
      this.errorDialog = false
      this.usersError = null
    },
    async fetchData() {
      this.teams = await userService.getTeams(this.companyId);
      this.teams = this.teams.data;
      this.officeItems = await userService.getOffices(this.companyId);
      this.officeItems = this.officeItems.data;
      if (this.userId) {
        this.userData = await userService.fetchById(this.userId);
        this.userData = this.userData.data;
        this.user.firstName = this.userData.firstName;
        this.user.lastName = this.userData.surname;
        this.user.email = this.userData.email;
        this.user.isDisabled = this.userData.isDisabled;
        this.selectedContract = this.userData.contractId;
        this.selectedOffice = this.userData.officeId;
        for (let i = 0; i < this.userData.assignedTeams.length; i++) {
          this.selectedTeam.push(
            this.userData.assignedTeams[i].teamId.toString()
          );
        }
        this.contractItems = await userService.getContracts(
          this.companyId,
          this.userData.contractId
        );
        this.contractDataToArray(this.contractItems);
        this.contractItemsSelect.push({ id: -1, description: "No contract" });
      } else {
        this.contractItems = await userService.getContracts(this.companyId, "");
        this.contractDataToArray(this.contractItems);
        this.selectedOffice = this.officeItems[0].officeId;
      }
    },
    check(email) {
      //  this.usersError = null
      return EMAIL_REGEX.test(email);
    },
    existingEmails() {
      let existingEmails = false
      this.bulkUsers.emails.map(email => {
        if (email.length) existingEmails = true
      })
      return existingEmails
    },
    submit(e) {
      this.showWarrningAdditionalInfo = false
      let returnCondition = false
      if (!this.bulkUsers.emails.length || !this.existingEmails()) {
        this.errorDialog = true
        this.usersError = 'Users emails are required';
        return;
      }
      if (this.bulkUsers.emails.length) {
        this.bulkUsers.emails.map(email => {
          if (email.length && !EMAIL_REGEX.test(email)) {
            this.usersError = 'Wrongly formatted emails';
            this.errorDialog = true;
            returnCondition = true;
            return
          };
        })
      }
      if (returnCondition) return;
      this.$validator.validate().then((result) => {
        if (result) {
          this.progressLoad = true;
          e.preventDefault();
          var dataCreate = {
            emails: this.bulkUsers.emails.filter(email => email != ''),
            companyId: this.companyId,
            officeId: this.selectedOffice,
            teamIds: this.selectedTeam,
            contractId: this.selectedContract,
            permittedLoginType: parseFloat(this.authMethod)
          };
          userService
            .bulkUserCreate(dataCreate)
            .then((res) => {
              this.progressLoad = false;
              if (res.data.status == 1) {
                this.success = true;
              } else {
                this.usersError = 'Some users could not be created'
                this.showWarrningAdditionalInfo = true
                this.errorDialog = true
                this.responseWarnings = res.data.details
              }
            })
            .catch((error) => {
              this.progressLoad = false;

              if (error.data.status == 0) {
                this.errorDialog = true
                this.responseWarnings = error.data.details
              }

              this.$validator.errors.add({
                field: error.data.data[0].errorField,
                msg: error.data.data[0].errorMessage,
              });
              if (error.status == 500) {
                this.errorDialog = true;
              }
            });
        }
      });
    },
    addMoreUsers() {
      if (
        this.usersEmailFieldCount + INCREMENT_USER_EMAIL_FIELDS_COUNT >=
        MAX_EMAIL_FIELDS
      ) {
        this.disableAddFieldsButton = true;
        this.usersEmailFieldCount = MAX_EMAIL_FIELDS;
      } else {
        this.usersEmailFieldCount += INCREMENT_USER_EMAIL_FIELDS_COUNT;
      }
    },
    csvToJSON(csv, callback) {
      let reader = new FileReader();
      reader.readAsText(csv);

      reader.onload = function (e) {
        let csv = reader.result;
        let lines = csv.split("\n");
        let result = [];

        for (let i = 0; i < lines.length; i++) {
          let obj = {};
          let cells = lines[i].split(",");

          for (let j = 0; j < cells.length; j++) {
            let cellToCheck = cells[j].replace(/\s/g, "");
            const isValid = EMAIL_REGEX.test(cellToCheck);
            if (isValid) {
              obj["email"] = cellToCheck;
              result.push(obj);
            }
          }
        }
        callback(result);
      };
    },
    updateImportedUsers(result) {
      const parsedResult = JSON.parse(JSON.stringify(result));
      parsedResult
        .slice(0, MAX_EMAIL_FIELDS - this.bulkUsers.emails.length)
        .map((result) => {
          this.bulkUsers.emails.push(result.email);
        });
      this.usersEmailFieldCount = this.bulkUsers.emails.length;
      if (this.usersEmailFieldCount == MAX_EMAIL_FIELDS)
        this.disableAddFieldsButton = true;
    },
    importFromCSV() {
      const fileName = event.target.files[0].name;
      const fileSize = event.target.files[0].size;
      const fileType = event.target.files[0].type;

      const acceptedMimeTypes = ["text/csv", "application/vnd.ms-excel"];
      if (acceptedMimeTypes.indexOf(fileType) != -1) {
        this.csvFileErrorType = false;
        this.csvFileErrorFormat = false;
        this.csvFileName = fileName;
        this.csvToJSON(event.target.files[0], this.updateImportedUsers);
      } else {
        this.csvFileErrorType = true;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
.create-bulk-users {
  .v-input {
    .v-text-field__details {
      position: absolute;
    }
  }
}

.valid-email-icon {
  position: absolute;
  right: 22px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  z-index: 1;
  padding: 2px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: 16px;
  }
}

.csv-uploader-button {
  .v-btn__content {
    align-self: stretch;
  }
}

#csv-uploader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -24px;
  opacity: 0;
  width: calc(100% + 24px + 16px); //lateral padding on .v-btn__content
  cursor: pointer;
}
</style>



